export const debounceTime = 400

export const chatgptAppUrl = 'https://chatgpt.com/plugins/plugin_asdk_app_6a058c8ecc248191b7d013eb03fd2727'
